/**
 * AccessDeniedPage Component
 *
 * Displayed when user successfully authenticates with Okta but lacks required group membership.
 * Provides instructions for requesting access via the Portal.
 */

import React, { useEffect, useState } from 'react';
import { OKTA_CONFIG, getUserEmail, signOut } from '../auth';

const AccessDeniedPage = () => {
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    const fetchEmail = async () => {
      const email = await getUserEmail();
      setUserEmail(email || 'your email');
    };
    fetchEmail();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Sign out error:', error);
      // Force redirect even if sign out fails
      window.location.href = '/';
    }
  };

  const handleRequestAccess = () => {
    window.open(OKTA_CONFIG.portalUrl, '_blank');
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      backgroundColor: '#f5f5f5',
      padding: '24px',
    }}>
      <div style={{
        textAlign: 'center',
        padding: '48px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        maxWidth: '600px',
        width: '100%',
      }}>
        <div style={{ fontSize: '64px', marginBottom: '24px' }}>🚫</div>

        <h1 style={{
          fontSize: '28px',
          marginBottom: '16px',
          color: '#333',
          fontWeight: '600',
        }}>
          Access Denied
        </h1>

        <p style={{
          fontSize: '16px',
          color: '#666',
          marginBottom: '24px',
          lineHeight: '1.6',
        }}>
          You have successfully authenticated as <strong>{userEmail}</strong>, but you do not have
          permission to access <strong>CSC Doc Gen Agent</strong>.
        </p>

        <div style={{
          backgroundColor: '#f9f9f9',
          border: '1px solid #e0e0e0',
          borderRadius: '6px',
          padding: '20px',
          marginBottom: '32px',
          textAlign: 'left',
        }}>
          <h3 style={{
            fontSize: '16px',
            marginBottom: '12px',
            color: '#333',
            fontWeight: '600',
          }}>
            To request access:
          </h3>
          <ol style={{
            paddingLeft: '20px',
            margin: '0',
            fontSize: '14px',
            color: '#666',
            lineHeight: '1.8',
          }}>
            <li>Click the "Request Access" button below to open the Portal</li>
            <li>Navigate to the Apps section</li>
            <li>Search for "CSC Doc Gen Agent"</li>
            <li>Click "Request Access" and submit your request</li>
            <li>Your manager will be notified to approve your request</li>
          </ol>
        </div>

        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}>
          <button
            onClick={handleRequestAccess}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '600',
              color: 'white',
              backgroundColor: '#1976d2',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#1565c0'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#1976d2'}
          >
            📝 Request Access
          </button>

          <button
            onClick={handleSignOut}
            style={{
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '600',
              color: '#666',
              backgroundColor: 'white',
              border: '1px solid #e0e0e0',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'border-color 0.2s',
            }}
            onMouseEnter={(e) => e.target.style.borderColor = '#999'}
            onMouseLeave={(e) => e.target.style.borderColor = '#e0e0e0'}
          >
            🚪 Sign Out
          </button>
        </div>

        <p style={{
          fontSize: '12px',
          color: '#999',
          marginTop: '32px',
          lineHeight: '1.5',
        }}>
          Required group: <code style={{
            backgroundColor: '#f5f5f5',
            padding: '2px 6px',
            borderRadius: '3px',
            fontSize: '11px',
          }}>{OKTA_CONFIG.requiredGroup}</code>
        </p>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
